// extracted by mini-css-extract-plugin
export default {"sample-size-footer":"SampleSizeFooter_sample-size-footer__AGE0w"};